import Nav from '../../Nav';
import { Container, Typography, Box, Grid, Card, CardContent, CardMedia } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import blog1 from "../images/card1.webp";
import blog2 from "../images/card2.webp";
import blog3 from "../images/card3.webp";
import blog4 from "../images/card4.webp";
import blog5 from "../images/photo5.jpg";
import blog6 from "../images/photo6.jpg";
import blog7 from "../images/photo7.jpg";
import Aos from "aos";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const blog = [
    {
        id: 1,
        image: blog1,
        title: "Possessive Pronouns",
        routingTitle:"Grammar/Possessive Pronouns",
        description: "Students often confuse the Possessive Pronouns in English with Possessive Nouns....",
        date: "7 June,2024",
    },
    {
        id: 2,
        image: blog2,
        title: "Is the verb 'be' interchangeable?",
        routingTitle:"Grammar/Is_the_verb_be_interchangeable?",
        description: "In English, the verb 'to be' is incredibly versatile and widely employed.It fulfills various roles....",
        date: "7 June,2024",
    },
    {
        id: 3,
        image: blog3,
        title: "Grammar Analysis - When it's time to See Your Doctor ",
        routingTitle:"Grammar/When_it’s_time_to_see_your_doctor",
        description: "During my recent visit to the clinic, I mentioned to the doctor,....",
        date: "7 June,2024",
    },
    {
        id: 4,
        image: blog4,
        title: "Which verbs aren’t interchangeable in English?",
        routingTitle:"Grammar/Which_verbs_aren’t_interchangeable_in_English?",
        description: "In English, certain verbs are not interchangeable because they convey....",
        date: "7 June,2024",
    },
];
const blogmain = [
    {
        id: 5,
        image: blog5,
        title: "Pronunciation Blog",
        routingTitle:"pronunciation",
        description: "",
        date: "7 June, 2024",
    },
    {
        id: 6,
        image: blog6,
        title: "Grammar Blog",
        routingTitle:"Grammar",
        description: "",
        date: "7 June, 2024",
    },
    {
        id: 7,
        image: blog7,
        title: "Other Articles",
        routingTitle:"motivational",
        description: "",
        date: "7 June, 2024",
    },
];

const Blog = () => {
    const navigate = useNavigate();

    const handleNavigation = (routingTitle, e) => {
        e.preventDefault();
        navigate(`/blog/${routingTitle}`);
    };

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    const cardStyles = {
        position: "relative",
        overflow: "hidden",
        borderRadius: 4,
        transition: "transform 0.2s",
        height: '450px',
        boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)',
        '&:hover': {
            transform: 'scale(1.05)',
            cursor: 'pointer',
        }
    };

    const additionalCardStyles = (id) => ({
        display: 'flex',
        alignItems: 'center',
        p: 2,
        backgroundColor: '#ffffff',
        borderRadius: 2,
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        borderRight: id === 6? '5px solid #80ffed' : 'none',
    });

    const cardMediaStyles = {
        width: 100,
        mr: 2,
        transition: 'transform 0.2s',
        '&:hover': {
            transform: 'scale(1.1)',
            cursor: 'pointer'
        },
        padding: '5px',
        height: '80px',
        boxSizing: 'border-box'
    };

    return (
        <>
            <Nav />
            <Box sx={{ backgroundColor: '#ffffff', py: 8, fontFamily: 'Arial, sans-serif' }}>
                <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
                    <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
                        <Typography variant="h2" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
                            Blog
                        </Typography>
                        <div id="image-container" className="absolute top-20 left-0">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
                        </div>
                        <div id="image-container2" className="absolute top-20 right-80">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute top-120 right-40">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute bottom-20 right-0">
                            <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
                        </div>
                    </Container>
                </Box>
                <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, mt: -8 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={8} >
                            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
                                Grammar Blog
                            </Typography>
                            <Grid container spacing={4}>
                                {blog.map((blog, index) => (
                                    <Grid item xs={12} sm={6} key={blog.id}>
                                        <Card
                                            data-aos='fade-up'
                                            sx={cardStyles}
                                            onClick={(e) => handleNavigation(blog.routingTitle, e)}
                                        >
                                            <CardMedia
                                                component="img"
                                                className="card-image"
                                                height="370"
                                                image={blog.image}
                                                alt={blog.title}
                                                sx={{ transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.1)' } }}
                                            />
                                            <CardContent>
                                                <Typography
                                                    gutterBottom
                                                    variant="h5"
                                                    component="div"
                                                    style={{ fontWeight: "bold" }}
                                                >
                                                    {blog.title}
                                                </Typography>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <CalendarTodayIcon sx={{ fontSize: 14, mr: 1 }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        {blog.date}
                                                    </Typography>
                                                </Box>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    dangerouslySetInnerHTML={{ __html: blog.description }}
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item xs={4}>
                            <Box sx={{
                                p: 3,
                                backgroundColor: '#f8fafc',
                                borderRadius: 2,
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                                position: 'sticky',
                                top: '80px',  
                                maxHeight: 'calc(100vh - 120px)',  
                                overflowY: 'auto',  
                            }}>
                                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
                                    Additional Blogs
                                </Typography>
                                <Grid container direction="column" spacing={4}>
                                    {blogmain.slice(0, 3).map((blog) => (
                                        <Grid item key={blog.id}>
                                            <Card
                                                sx={additionalCardStyles(blog.id)}
                                                onClick={(e) => handleNavigation(blog.routingTitle, e)}
                                            >
                                                <CardMedia
                                                    component="img"
                                                    className="card-image"
                                                    height="200"
                                                    image={blog.image}
                                                    alt={blog.title}
                                                    sx={cardMediaStyles}
                                                />
                                                <CardContent sx={{ p: 0 }}>
                                                    <Typography
                                                        gutterBottom
                                                        variant="h6"
                                                        component="div"
                                                        style={{ fontWeight: "bold" }}
                                                    >
                                                        {blog.title}
                                                    </Typography>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                        <CalendarTodayIcon sx={{ fontSize: 14, mr: 1 }} />
                                                        <Typography variant="body2" color="text.secondary">
                                                            {blog.date}
                                                        </Typography>
                                                    </Box>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                        dangerouslySetInnerHTML={{ __html: blog.description }}
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>

                </Container>
            </Box>
        </>
    );
};

export default Blog;
